import React from 'react';
import { connect } from 'react-redux';

import { FormErrors } from 'src/components';
import {
  EditActionBtn,
  SaveActionBtn,
  AddActionBtn,
  CancelActionBtn,
  ExpandActionBtn,
  CollapseActionBtn
} from 'src/buttons';

import {
  getMode,
  getErrors,
  expandAll,
  collapseAll,
  changeToEditMode,
  changeToShowMode,
  addNone,
  updateAllGroupNodes,
  MODES
} from 'src/reducers/clients/groups';
import styles from './GroupsButtons.scss';

const GroupsButtons = ({
  isEditMode,
  errors,
  onExpandAllClick,
  onCollapseAllClick,
  onChangeToEditModeClick,
  onAddClick,
  onCancelClick,
  onSaveClick,
  anyApiRunning
}) => (
  <div>
    <FormErrors errors={errors} />
    <div className={styles.action}>
      <ExpandActionBtn onClick={onExpandAllClick} />
      <CollapseActionBtn onClick={onCollapseAllClick} />
      {isEditMode && <AddActionBtn onClick={onAddClick} />}
      {isEditMode && <SaveActionBtn onClick={onSaveClick} />}
      {isEditMode && <CancelActionBtn onClick={onCancelClick} />}
      {!isEditMode && <EditActionBtn onClick={onChangeToEditModeClick} disabled={anyApiRunning} />}
    </div>
  </div>
);

const mapStateToProps = state => ({
  isEditMode: getMode(state) === MODES.EDIT,
  errors: getErrors(state)
});
const mapDispatchToProps = dispatch => ({
  onExpandAllClick: () => {
    dispatch(expandAll());
  },
  onCollapseAllClick: () => {
    dispatch(collapseAll());
  },
  onChangeToEditModeClick: () => {
    dispatch(changeToEditMode());
  },
  onAddClick: () => {
    dispatch(addNone());
  },
  onCancelClick: () => {
    dispatch(changeToShowMode());
  },
  onSaveClick: () => {
    dispatch(updateAllGroupNodes());
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(GroupsButtons);
